import axiosInstance from './axiosInstance';

const downloadPdf = async (endpoint, data, fallbackName) => {
    try {
        const res = await axiosInstance.post(`/FormGenerator/${endpoint}`, data, { responseType: 'blob' });
        const contentDisposition = res.headers['content-disposition'];
        let fileName = fallbackName;
        if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
            if (match) fileName = decodeURIComponent(match[1].replace(/"/g, ''));
        }
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (err) {
        // When responseType is blob, error response body is also a blob - read it as text
        if (err.response?.data instanceof Blob) {
            const text = await err.response.data.text();
            throw new Error(text);
        }
        throw err;
    }
};

// Sales title (display-only) for a user — shown on the namecard + profile.
export const getSalesTitle = (userId) => axiosInstance.get('/FormGenerator/SalesTitle', { params: { userId } });

// Namecard — GET (server builds from the user's own record by userId).
export const generateNamecard = async (userId) => {
    const res = await axiosInstance.get('/FormGenerator/GenerateNamecard', { params: { userId }, responseType: 'blob' });
    const cd = res.headers['content-disposition'];
    let fileName = 'Namecard.pdf';
    if (cd) {
        const m = cd.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
        if (m) fileName = decodeURIComponent(m[1].replace(/"/g, ''));
    }
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url; a.download = fileName;
    document.body.appendChild(a); a.click(); a.remove();
    window.URL.revokeObjectURL(url);
};

export const generateAtap = (data) => downloadPdf('GenerateAtap', data, `${data.name} (ATAP).pdf`);
export const generateQuotation = (data) => downloadPdf('GenerateQuotation', data, `${data.name} (QUOTATION).pdf`);
export const generateQuotation2 = (data) => downloadPdf('GenerateQuotation2', data, `Quotation (${data.name}).pdf`);
export const generateQuotationNoBackupbox = (data) => downloadPdf('GenerateQuotationNoBackupbox', data, `${data.name} (QUOTATION - WITHOUT BACKUPBOX).pdf`);
export const generateDeclaration = (data) => downloadPdf('GenerateDeclaration', data, `${data.name} (DECLARATION).pdf`);
export const generateInsurance = (data) => downloadPdf('GenerateInsurance', data, `${data.name} (INSURANCE).pdf`);
export const generateInsurance2 = (data) => downloadPdf('GenerateInsurance2', data, `Insurance Form (${data.name}).pdf`);
export const generateBooking = (data) => downloadPdf('GenerateBooking', data, `${data.name} (BOOKING).pdf`);
export const generateBooking2 = (data) => downloadPdf('GenerateBooking2', data, `Booking Form (${data.name}).pdf`);
export const generateAll = (data) => downloadPdf('GenerateAll', data, `${data.name} - All Forms.zip`);

// Commercial
export const generateCommercialAtap = (data) => downloadPdf('GenerateCommercialAtap', data, `Solar ATAP Contract (${data.companyName}).pdf`);
export const generateCommercialDeclaration = (data) => downloadPdf('GenerateCommercialDeclaration', data, `Declaration (${data.companyName}).pdf`);
export const generateCommercialQuotation = (data) => downloadPdf('GenerateCommercialQuotation', data, `Quotation (${data.companyName}).pdf`);
export const generateCommercialQuotation2 = (data) => downloadPdf('GenerateCommercialQuotation2', data, `Quotation (${data.companyName}).pdf`);
export const generateCommercialInsurance = (data) => downloadPdf('GenerateCommercialInsurance', data, `Insurance Form (${data.companyName}).pdf`);
export const generateCommercialInsurance2 = (data) => downloadPdf('GenerateCommercialInsurance2', data, `Insurance Form (${data.companyName}).pdf`);
export const generateCommercialAll = (data) => downloadPdf('GenerateCommercialAll', data, `${data.companyName} - Commercial Forms.zip`);
